module.exports = __webpack_public_path__ + "img/eit3-flow2.e9f4a958.png";